import request from './fetch';

export function getAzureBlobUrl(file_key) {
  return request({
    url: '/v1/azure_file',
    method: 'put',
    params: {file_key: file_key}
  });

}